import { useEffect, useState } from "react";
import { api, AppConfig, ApiError } from "../api/client";
import { useToast } from "../ui/toast";

/** Warunki licencji — edit the license terms served to the client app via /config. */
export function LicenseTerms() {
  const toast = useToast();
  const [cfg, setCfg] = useState<AppConfig | null>(null);
  const [original, setOriginal] = useState<AppConfig | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.getConfig()
      .then((c) => { setCfg(c); setOriginal(c); })
      .catch((e: ApiError) => toast(e.status === 403 ? "Brak dostępu (owner-only)." : e.message));
  }, [toast]);

  if (!cfg || !original) return <div className="card empty">Ładowanie…</div>;
  const changed =
    cfg.tos.text !== original.tos.text || (cfg.tos.textEn ?? "") !== (original.tos.textEn ?? "");

  const save = async () => {
    setBusy(true);
    try {
      const saved = await api.saveConfig(cfg);
      setCfg(saved);
      setOriginal(saved);
      toast(`Zapisano warunki licencji (wersja ${saved.tos.version})`);
    } catch (e) {
      toast((e as ApiError).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card" style={{ padding: 20, maxWidth: 860 }}>
      <div className="section-title" style={{ marginBottom: 4 }}>Warunki licencji</div>
      <div className="section-hint">
        Treść jest serwowana do aplikacji klienckiej (/config) i wyświetlana w karcie „Licencja".
        Każda zmiana <b>podbija wersję warunków</b> i wymusza ponowną akceptację u wszystkich klientów
        przy następnym uruchomieniu aplikacji.
      </div>

      <div className="field" style={{ marginTop: 14 }}>
        <label className="label">Treść warunków licencji</label>
        <textarea
          className="textarea"
          style={{ minHeight: 340 }}
          value={cfg.tos.text}
          placeholder="Wpisz treść warunków licencji, które zaakceptuje użytkownik aplikacji…"
          onChange={(e) => setCfg({ ...cfg, tos: { ...cfg.tos, text: e.target.value } })}
        />
      </div>

      <div className="field" style={{ marginTop: 14 }}>
        <label className="label">Treść w języku angielskim (EN) — pokazywana klientom, którzy wybrali English</label>
        <textarea
          className="textarea"
          style={{ minHeight: 340 }}
          value={cfg.tos.textEn ?? ""}
          placeholder="Enter the English version of the licence terms…"
          onChange={(e) => setCfg({ ...cfg, tos: { ...cfg.tos, textEn: e.target.value } })}
        />
      </div>

      <div className="row" style={{ marginTop: 12 }}>
        <span className="faint" style={{ fontSize: 12 }}>Aktualna wersja: {original.tos.version}</span>
        {changed && (
          <span className="badge st-expiring" style={{ marginLeft: 8 }}>
            <span className="dot dot-expiring" />wersja zostanie podbita
          </span>
        )}
        <div className="topbar-spacer" />
        <button className="btn primary" disabled={busy || !changed} onClick={save}>Zapisz warunki</button>
      </div>
    </div>
  );
}
